import styled from "styled-components";

const Mobile = styled.div`
  @media (max-width: 575px) {
    display: block;
  }
  @media (min-width: 576px) {
    display: none;
  }
`;

export default Mobile;



// WEBPACK FOOTER //
// ./src/components/Breakpoints/Mobile.js